import lscache from 'lscache'

const storageExpireSeconds = 24 * 60 * 60

export const getFromStorage = (
  key,
  defaultValue,
  expire = storageExpireSeconds
) => {
  lscache.flushExpired()
  const storedValue = lscache.get(key)
  if (storedValue != null) {
    return storedValue
  }

  storeToStorage(key, defaultValue, expire)
  return defaultValue
}

export const storeToStorage = (key, val, expire = storageExpireSeconds) => {
  lscache.flushExpired()
  lscache.set(key, val, expire)
}

export const removeFromStorage = (key) => {
  lscache.flushExpired()
  lscache.remove(key)
}

/**
 * sessionStorageから値を取得する
 *
 * @param {string} key - キー
 * @param {any} defaultValue - ストレージにない場合のデフォルト値
 * @returns {any} - キーが存在する場合はsessionStorageからの値、存在しない場合はデフォルト値。
 */
export const getFromSessionStorage = (key, defaultValue) => {
  const val = sessionStorage.get(key)
  return val ? val : defaultValue
}

/**
 * Stores a value in the session storage.
 *
 * @param {string} key - The key used to store the value.
 * @param {*} val - The value to be stored.
 * @returns {void}
 */
export const storeToSessionStorage = (key, val) => {
  sessionStorage.set(key, val)
}
